export default {
  title: 'Betalingsgateways',
  fields: {
    name: 'Navn',
    payment_gateway: 'Betalingsgateways',
    live_from: 'Live siden',
    last_30_days_sales: 'Salg de seneste 30 dage',
    kyc_deadlines: 'KYC-frister',
    actions: 'Handlinger',
  },
  stats: {
    active_on_stripe: 'Aktiv på Stripe',
    active_on_adyen: 'Aktiv på Adyen',
    adyen_verification_pending: 'Adyen-verifikation afventer',
  },
  filters: {
    search_placeholder: 'Søg efter navn...',
    gateway_status_placeholder: 'Alle gateways',
  },
  not_configured: {
    title: 'Betalinger er endnu ikke konfigureret',
    description:
      'Ingen betalingsudbyder er tilsluttet din konto. Restauranter kan sættes helt op, men de kan ikke gå live eller modtage onlinebetalinger, før betalinger er konfigureret.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (afventer)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verificeret',
    pending: 'Afventer',
    rejected: 'Afvist',
  },
  buttons: {
    actions: 'Handlinger',
    switch_to: 'Skift til {{gateway}}',
    view_details: 'Se detaljer',
    open_onboarding: 'Åbn onboarding',
    create_onboarding_link: 'Opret onboarding-link',
  },
  modal: {
    title: 'Skift betalingsgateway',
    description:
      'Er du sikker på, at du vil skifte {{companyName}} fra <bold>{{currentGateway}}</bold> til <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} er ikke verificeret for denne virksomhed. Betalingsbehandlingen kan blive påvirket.',
    confirm: 'Skift',
    cancel: 'Annuller',
  },
  details_modal: {
    title: '{{companyName}} — Detaljer om betalingsgateway',
    requirements: 'Krav',
    no_requirements: 'Ingen afventende krav.',
    deadline: 'Frist',
    capabilities: 'Funktioner',
    onboarding_links: {
      section_title: 'Onboarding-link',
      active_link: 'Aktivt link',
      expires: 'Udløber {{date}}',
      create_button: 'Opret link',
      extend_button: 'Forlæng link',
      loading: 'Indlæser links…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Onboarding-linket kunne ikke oprettes.',
    switch_success: 'Betalingsgatewayen blev skiftet.',
    switch_failed: 'Betalingsgatewayen kunne ikke skiftes.',
    failed_to_load_data: 'Dataene kunne ikke indlæses.',
  },
};
